<template>
  <el-drawer v-model="visible" :title="params.title || '入群二维码'" :size="500">
    <div class="qr-code-box" ref="qrCodeBox">
      <div class="qr-code-label" v-text="params.label"></div>
      <div class="qu-code-img-box">
        <img :src="qrCodeImg" alt="" class="qr-code-img">
        <el-avatar class="qr-code-logo" v-if="params.logo" :src="getFileUrl(params.logo)" :size="50"></el-avatar>
      </div>
      <div class="qr-code-sub-label" v-text="params.subLabel"></div>
    </div>
    <div class="qr-code-download-box" v-if="params.isDownload !== false">
      <el-button plain auto-insert-space size="large" @click="downloadQrCode">下载二维码图片</el-button>
    </div>
  </el-drawer>
</template>

<script>
import { defineComponent } from 'vue';
import QRcode from 'qrcode'
import html2canvas  from 'html2canvas'
import logoV from '@/assets/logoV.png'
import { QR_CODE_URL, getFileUrl } from '@/utils/common';
import { downloadFile } from '@/utils/fileUtil';

export default defineComponent({
  components: { },
  emits: ['update:modelValue'],
  props: {
    modelValue: false,
    /**  
     * {
     *  type: 类型 1 加入项目, 2 加入班组, 3 加入施工队, 4 查看人员信息, 5 将员工设为负责人等角色,
     *    11 企业角色添加人员
     * id id
     * orgId: orgId
     * unitId: unitId
     * title 标题
     * label 标签
     * subLabel: 子标签
     * logo logo地址
     * isDownload: 是否显示下载，默认显示
     * }
    */ 
    params: Object 
  },
  data() {
    return {
      getFileUrl,
      logoV,
      qrCodeImg: null
    }
  },
  computed: {
    visible: {
      get() {
          return this.modelValue; 
      },
      set(value) {
          this.$emit('update:modelValue', value); 
      }
    },
  },
  watch: {
    visible(val) {
      val && this.generateQrCode()
    }
  },
  methods: {
    generateQrCode() {
      let idString = "";
      if (this.params.id) {
        idString = `"id":"${this.params.id}"`
      } else if (this.params.unitId) {
        idString = `"unitId":"${this.params.unitId}"`
      } else if (this.params.orgId) {
        idString = `"orgId":"${this.params.orgId}"`
      }

      QRcode.toDataURL(`${QR_CODE_URL}params={${idString},"type":${this.params.type}}`, {
        type: "image/png", //类型
        quality: 0.5, //图片质量A Number between 0 and 1
        width: 100, //高度
        height: 100, //宽度
        errorCorrectionLevel: "L", //容错率
        margin: 1, //外边距
        color: {
          dark: "#1296db", //前景色
          light: "#f5f5f5" //背景色
        },
        logo: this.logoV
      }).then(imgData => {
        this.qrCodeImg = imgData;
      })
    },
    downloadQrCode() {
      html2canvas(this.$refs.qrCodeBox).then(canvas => {
        let saveUrl = canvas.toDataURL('image/png');
        downloadFile(saveUrl, this.params.label);
      })
    }
  }
})
</script>

<style lang="scss" scoped>
.qr-code-box {
  background-color: #f5f5f5;
  width: 400px;
  margin: 0 auto;
  padding: 50px 30px;
  text-align: center;
  position: relative;
  .qr-code-label {
    margin-bottom: 30px;
    font-size: 1.3em;
  }
  .qr-code-sub-label {
    margin-top: 25px;
    color: #bbb;
  }
  .qu-code-img-box {
    position: relative;
    .qr-code-img {
      width: 250px;
      height: 250px;
    }
    .qr-code-logo {
      position: absolute;
      left: 145px;
      top: 100px;
    }
  }
  
}
.qr-code-download-box {
  text-align: center;
  margin-top: 50px;
  .el-button {
    color: #000;
    font-weight: bold;
    font-size: 1.5em;
    border-color: #8d8d8d;
    border-radius: 10px;
    width: 350px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
</style>